
import {
    Container,
    Typography,
    Box,
    Card,
    CardContent,
    Divider,
    CircularProgress,
    Chip,
} from "@mui/material";

import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CampaignIcon from "@mui/icons-material/Campaign";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";

import { useEffect, useState } from "react";
import FadeIn from "react-fade-in";
import config from "../config.json";
import axios from "axios";
import parse from "html-react-parser";

export const ServerNews = () => {
    const apiEndPoint =
        config.apiEndPoint + "info/server-news";

    const [news, setNews] = useState(null);

    useEffect(() => {
        axios
            .get(apiEndPoint)
            .then((res) => setNews(res.data));
    }, []);

    return (
        <Box
            sx={{
                minHeight: "100vh",
                position: "relative",
                overflow: "hidden",
                py: { xs: 7, md: 10 },
                background:
                    "radial-gradient(circle at 50% -10%, rgba(255,84,32,0.14), transparent 38%), radial-gradient(circle at 100% 45%, rgba(181,42,13,0.045), transparent 32%), linear-gradient(180deg, #030303 0%, #080808 55%, #020202 100%)",
                color: "#fff",

                "&:before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "65%",
                    height: "1px",
                    background:
                        "linear-gradient(90deg, transparent, rgba(255,84,32,0.85), transparent)",
                },

                "&:after": {
                    content: '""',
                    position: "absolute",
                    inset: 0,
                    backgroundImage:
                        "linear-gradient(rgba(255,84,32,0.018) 1px, transparent 1px), linear-gradient(90deg, rgba(255,84,32,0.018) 1px, transparent 1px)",
                    backgroundSize: "45px 45px",
                    pointerEvents: "none",
                },
            }}
        >
            {/* =========================================
                BACKGROUND FIRE GLOW - TOP RIGHT
            ========================================= */}

            <Box
                sx={{
                    position: "absolute",
                    top: "-220px",
                    right: "-220px",
                    width: "550px",
                    height: "550px",
                    borderRadius: "50%",
                    background:
                        "radial-gradient(circle, rgba(255,84,32,0.15) 0%, rgba(181,42,13,0.045) 38%, transparent 70%)",
                    filter: "blur(110px)",
                    pointerEvents: "none",
                }}
            />

            {/* =========================================
                BACKGROUND FIRE GLOW - BOTTOM LEFT
            ========================================= */}

            <Box
                sx={{
                    position: "absolute",
                    bottom: "-250px",
                    left: "-250px",
                    width: "600px",
                    height: "600px",
                    borderRadius: "50%",
                    background:
                        "radial-gradient(circle, rgba(255,84,32,0.065) 0%, rgba(142,29,11,0.025) 38%, transparent 70%)",
                    filter: "blur(120px)",
                    pointerEvents: "none",
                }}
            />

            {/* =========================================
                CENTER EMBER GLOW
            ========================================= */}

            <Box
                sx={{
                    position: "absolute",
                    top: "42%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "600px",
                    height: "600px",
                    borderRadius: "50%",
                    background:
                        "radial-gradient(circle, rgba(255,84,32,0.025), transparent 70%)",
                    filter: "blur(110px)",
                    pointerEvents: "none",
                }}
            />

            {/* =========================================
                CONTENT
            ========================================= */}

            <Container
                maxWidth="lg"
                sx={{
                    position: "relative",
                    zIndex: 2,
                }}
            >
                {/* =====================================
                    HEADER
                ===================================== */}

                <Box
                    sx={{
                        textAlign: "center",
                        mb: { xs: 6, md: 8 },
                    }}
                >
                    <Typography
                        sx={{
                            color: "#ff7135",
                            fontWeight: 800,
                            letterSpacing: "5px",
                            fontSize: "12px",
                            mb: 2,
                            textShadow:
                                "0 0 20px rgba(255,84,32,0.2)",
                        }}
                    >
                        VEX • OFFICIAL SERVER NEWS
                    </Typography>

                    <Typography
                        sx={{
                            fontWeight: 900,
                            fontSize: {
                                xs: "42px",
                                sm: "52px",
                                md: "68px",
                            },
                            lineHeight: 1,
                            letterSpacing: "-1px",
                            color: "#fff",
                            mb: 3,
                            textShadow:
                                "0 5px 30px rgba(0,0,0,0.65)",
                        }}
                    >
                        Latest{" "}
                        <span
                            style={{
                                color: "#ff7135",
                                textShadow:
                                    "0 0 30px rgba(255,84,32,0.25)",
                            }}
                        >
                            Updates
                        </span>
                    </Typography>

                    <Typography
                        sx={{
                            color: "rgba(255,255,255,0.60)",
                            maxWidth: "720px",
                            mx: "auto",
                            fontSize: {
                                xs: "15px",
                                md: "18px",
                            },
                            lineHeight: 1.9,
                        }}
                    >
                        Stay informed with the latest announcements,
                        events, maintenance schedules, gameplay updates,
                        fixes, and new features from Vex Conquer.
                    </Typography>

                    {/* FIRE ACCENT */}

                    <Box
                        sx={{
                            width: 90,
                            height: 3,
                            borderRadius: "10px",
                            background:
                                "linear-gradient(90deg, transparent, #ff5420, #ff9a4d, #ff5420, transparent)",
                            mx: "auto",
                            mt: 3,
                            boxShadow:
                                "0 0 15px rgba(255,84,32,0.25)",
                        }}
                    />

                    {/* SERVER TAGS */}

                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            flexWrap: "wrap",
                            gap: 1,
                            mt: 3,
                        }}
                    >
                        {[
                            "5165 CLASSIC",
                            "LEVEL 130",
                            "1ST REBORN",
                            "CLASSIC PVP",
                        ].map((tag) => (
                            <Box
                                key={tag}
                                sx={{
                                    px: 1.5,
                                    py: 0.7,
                                    borderRadius: "6px",
                                    border:
                                        "1px solid rgba(255,84,32,0.16)",
                                    background:
                                        "rgba(255,84,32,0.045)",
                                    color: "#999",
                                    fontSize: "9px",
                                    fontWeight: 800,
                                    letterSpacing: "1.2px",
                                }}
                            >
                                {tag}
                            </Box>
                        ))}
                    </Box>
                </Box>

                {/* =====================================
                    LOADING
                ===================================== */}

                {!news ? (
                    <Box
                        sx={{
                            minHeight: "300px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "28px",
                            background:
                                "linear-gradient(145deg, rgba(18,10,8,0.98), rgba(8,8,8,0.98))",
                            border:
                                "1px solid rgba(255,84,32,0.12)",
                            boxShadow:
                                "0 25px 70px rgba(0,0,0,0.5)",
                            position: "relative",
                            overflow: "hidden",

                            "&:before": {
                                content: '""',
                                position: "absolute",
                                top: 0,
                                left: "50%",
                                transform: "translateX(-50%)",
                                width: "40%",
                                height: "2px",
                                background:
                                    "linear-gradient(90deg, transparent, #ff5420, transparent)",
                            },
                        }}
                    >
                        <CircularProgress
                            size={42}
                            thickness={3}
                            sx={{
                                color: "#ff5420",
                                filter:
                                    "drop-shadow(0 0 8px rgba(255,84,32,0.4))",
                            }}
                        />

                        <Typography
                            sx={{
                                mt: 3,
                                color: "#888",
                                fontSize: "14px",
                            }}
                        >
                            Loading server updates...
                        </Typography>

                        <Typography
                            sx={{
                                mt: 0.7,
                                color: "#444",
                                fontSize: "9px",
                                fontWeight: 800,
                                letterSpacing: "1.5px",
                            }}
                        >
                            VEX CONQUER • 5165 CLASSIC
                        </Typography>
                    </Box>
                ) : news.length === 0 ? (
                    /* =================================
                       EMPTY
                    ================================= */

                    <Box
                        sx={{
                            textAlign: "center",
                            py: 10,
                            px: 3,
                            borderRadius: "28px",
                            background:
                                "linear-gradient(145deg, rgba(18,10,8,0.99), rgba(8,8,8,0.99))",
                            border:
                                "1px solid rgba(255,84,32,0.15)",
                            boxShadow:
                                "0 20px 60px rgba(0,0,0,0.55)",
                            position: "relative",
                            overflow: "hidden",

                            "&:before": {
                                content: '""',
                                position: "absolute",
                                top: 0,
                                left: "50%",
                                transform: "translateX(-50%)",
                                width: "35%",
                                height: "2px",
                                background:
                                    "linear-gradient(90deg, transparent, #ff5420, transparent)",
                            },
                        }}
                    >
                        <CampaignIcon
                            sx={{
                                fontSize: 48,
                                color: "#ff7135",
                                mb: 2,
                                filter:
                                    "drop-shadow(0 0 12px rgba(255,84,32,0.35))",
                            }}
                        />

                        <Typography
                            sx={{
                                color: "#fff",
                                fontWeight: 800,
                                fontSize: "24px",
                                mb: 1,
                            }}
                        >
                            No Updates Yet
                        </Typography>

                        <Typography
                            sx={{
                                color: "#777",
                                fontSize: "14px",
                            }}
                        >
                            There are currently no server announcements.
                        </Typography>
                    </Box>
                ) : (
                    /* =================================
                       NEWS LIST
                    ================================= */

                    <FadeIn>
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: { xs: 3, md: 5 },
                            }}
                        >
                            {news.map((e, idx) => (
                                <Card
                                    key={idx}
                                    elevation={0}
                                    sx={{
                                        position: "relative",
                                        overflow: "hidden",
                                        borderRadius: {
                                            xs: "20px",
                                            md: "28px",
                                        },
                                        background:
                                            "linear-gradient(135deg, rgba(18,10,8,0.99) 0%, rgba(8,8,8,0.99) 100%)",
                                        border:
                                            "1px solid rgba(255,84,32,0.14)",
                                        boxShadow:
                                            "0 25px 70px rgba(0,0,0,0.5)",
                                        transition:
                                            "transform 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease",

                                        "&:hover": {
                                            transform:
                                                "translateY(-5px)",
                                            border:
                                                "1px solid rgba(255,84,32,0.34)",
                                            boxShadow:
                                                "0 30px 85px rgba(0,0,0,0.7), 0 0 30px rgba(255,84,32,0.035)",
                                        },
                                    }}
                                >
                                    {/* TOP FIRE LINE */}

                                    <Box
                                        sx={{
                                            height: "4px",
                                            width: "100%",
                                            background:
                                                "linear-gradient(90deg, #8e1d0b, #d52f0c, #ff5420, #ff9a4d, #ff5420, #d52f0c, #8e1d0b)",
                                            boxShadow:
                                                "0 0 14px rgba(255,84,32,0.18)",
                                        }}
                                    />

                                    {/* INNER FIRE GLOW */}

                                    <Box
                                        sx={{
                                            position: "absolute",
                                            top: "-160px",
                                            right: "-160px",
                                            width: "320px",
                                            height: "320px",
                                            borderRadius: "50%",
                                            background:
                                                "radial-gradient(circle, rgba(255,84,32,0.09), rgba(181,42,13,0.025), transparent 70%)",
                                            filter: "blur(50px)",
                                            pointerEvents: "none",
                                        }}
                                    />

                                    {/* SMALL SIDE GLOW */}

                                    <Box
                                        sx={{
                                            position: "absolute",
                                            bottom: "-120px",
                                            left: "-120px",
                                            width: "250px",
                                            height: "250px",
                                            borderRadius: "50%",
                                            background:
                                                "radial-gradient(circle, rgba(255,84,32,0.035), transparent 70%)",
                                            filter: "blur(55px)",
                                            pointerEvents: "none",
                                        }}
                                    />

                                    <CardContent
                                        sx={{
                                            position: "relative",
                                            zIndex: 2,
                                            p: {
                                                xs: 3,
                                                sm: 4,
                                                md: 5,
                                            },
                                            "&:last-child": {
                                                pb: {
                                                    xs: 3,
                                                    sm: 4,
                                                    md: 5,
                                                },
                                            },
                                        }}
                                    >
                                        {/* META */}

                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexWrap: "wrap",
                                                alignItems: "center",
                                                justifyContent:
                                                    "space-between",
                                                gap: 2,
                                                mb: 3,
                                            }}
                                        >
                                            <Chip
                                                icon={
                                                    <CampaignIcon
                                                        sx={{
                                                            color:
                                                                "#ff7135 !important",
                                                        }}
                                                    />
                                                }
                                                label="Official Announcement"
                                                sx={{
                                                    height: 34,
                                                    background:
                                                        "rgba(255,84,32,0.08)",
                                                    color: "#ff7135",
                                                    border:
                                                        "1px solid rgba(255,84,32,0.18)",
                                                    fontWeight: 800,
                                                    fontSize: "11px",
                                                    borderRadius:
                                                        "10px",
                                                    boxShadow:
                                                        "0 0 18px rgba(255,84,32,0.035)",
                                                    "& .MuiChip-label": {
                                                        px: 1.5,
                                                    },
                                                }}
                                            />

                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems:
                                                        "center",
                                                    gap: 1,
                                                }}
                                            >
                                                <AccessTimeIcon
                                                    sx={{
                                                        fontSize: 17,
                                                        color:
                                                            "#ff7135",
                                                    }}
                                                />

                                                <Typography
                                                    sx={{
                                                        color:
                                                            "rgba(255,255,255,0.45)",
                                                        fontSize: "12px",
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    {new Date(
                                                        e.date
                                                    ).toLocaleString()}
                                                </Typography>
                                            </Box>
                                        </Box>

                                        {/* TITLE */}

                                        <Typography
                                            sx={{
                                                color: "#fff",
                                                fontWeight: 900,
                                                fontSize: {
                                                    xs: "27px",
                                                    sm: "32px",
                                                    md: "40px",
                                                },
                                                lineHeight: 1.15,
                                                letterSpacing:
                                                    "-0.5px",
                                                mb: 3,
                                            }}
                                        >
                                            {e.title}
                                        </Typography>

                                        {/* DIVIDER */}

                                        <Divider
                                            sx={{
                                                mb: 3,
                                                borderColor:
                                                    "rgba(255,255,255,0.07)",
                                            }}
                                        />

                                        {/* CONTENT */}

                                        <Box
                                            sx={{
                                                color:
                                                    "rgba(255,255,255,0.70)",
                                                fontSize: {
                                                    xs: "15px",
                                                    md: "16px",
                                                },
                                                lineHeight: 1.9,

                                                "& p": {
                                                    marginTop: 0,
                                                    marginBottom: 2,
                                                },

                                                "& strong": {
                                                    color: "#ff7135",
                                                    fontWeight: 800,
                                                },

                                                "& h1, & h2, & h3, & h4": {
                                                    color: "#fff",
                                                    fontWeight: 800,
                                                    marginTop: 3,
                                                    marginBottom: 2,
                                                },

                                                "& ul, & ol": {
                                                    paddingLeft: 3,
                                                    marginBottom: 2,
                                                },

                                                "& li": {
                                                    marginBottom: 1,
                                                },

                                                "& a": {
                                                    color: "#ff9a4d",
                                                    fontWeight: 700,
                                                    transition:
                                                        "color 0.2s ease",

                                                    "&:hover": {
                                                        color: "#ff5420",
                                                    },
                                                },

                                                "& img": {
                                                    display: "block",
                                                    maxWidth: "100%",
                                                    height: "auto",
                                                    borderRadius: "16px",
                                                    marginTop: 3,
                                                    marginBottom: 3,
                                                    border:
                                                        "1px solid rgba(255,84,32,0.16)",
                                                    boxShadow:
                                                        "0 15px 40px rgba(0,0,0,0.45)",
                                                },

                                                "& blockquote": {
                                                    margin: "24px 0",
                                                    padding:
                                                        "16px 20px",
                                                    borderLeft:
                                                        "3px solid #ff5420",
                                                    background:
                                                        "rgba(255,84,32,0.045)",
                                                    color: "#ccc",
                                                    borderRadius:
                                                        "0 12px 12px 0",
                                                    boxShadow:
                                                        "inset 0 0 25px rgba(255,84,32,0.018)",
                                                },
                                            }}
                                        >
                                            {parse(e.content)}
                                        </Box>

                                        {/* BOTTOM ACCENT */}

                                        <Box
                                            sx={{
                                                mt: 4,
                                                pt: 3,
                                                borderTop:
                                                    "1px solid rgba(255,255,255,0.06)",
                                                display: "flex",
                                                alignItems:
                                                    "center",
                                                justifyContent:
                                                    "space-between",
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems:
                                                        "center",
                                                    gap: 1.2,
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        width: 6,
                                                        height: 6,
                                                        borderRadius:
                                                            "50%",
                                                        background:
                                                            "#ff5420",
                                                        boxShadow:
                                                            "0 0 10px rgba(255,84,32,0.55)",
                                                    }}
                                                />

                                                <Typography
                                                    sx={{
                                                        color:
                                                            "rgba(255,255,255,0.35)",
                                                        fontSize: "11px",
                                                        fontWeight: 700,
                                                        letterSpacing:
                                                            "2px",
                                                    }}
                                                >
                                                    VEX CONQUER
                                                </Typography>
                                            </Box>

                                            <ArrowForwardRoundedIcon
                                                sx={{
                                                    fontSize: 18,
                                                    color:
                                                        "rgba(255,84,32,0.6)",
                                                    transition:
                                                        "transform 0.2s ease, color 0.2s ease",
                                                }}
                                            />
                                        </Box>
                                    </CardContent>
                                </Card>
                            ))}
                        </Box>
                    </FadeIn>
                )}

                {/* =====================================
                    BOTTOM SERVER INFO
                ===================================== */}

                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: {
                            xs: "1fr",
                            sm: "repeat(3, 1fr)",
                        },
                        gap: 1.5,
                        mt: { xs: 5, md: 7 },
                    }}
                >
                    {[
                        {
                            value: "5165",
                            label: "CLASSIC CORE",
                        },
                        {
                            value: "130",
                            label: "MAX LEVEL",
                        },
                        {
                            value: "PVP",
                            label: "CLASSIC BATTLES",
                        },
                    ].map((item) => (
                        <Box
                            key={item.label}
                            sx={{
                                textAlign: "center",
                                py: 2.2,
                                px: 2,
                                borderRadius: "12px",
                                border:
                                    "1px solid rgba(255,84,32,0.09)",
                                background:
                                    "linear-gradient(145deg, rgba(255,84,32,0.035), rgba(255,255,255,0.012))",
                            }}
                        >
                            <Typography
                                sx={{
                                    color: "#ff7135",
                                    fontSize: "16px",
                                    fontWeight: 900,
                                    letterSpacing: "1px",
                                }}
                            >
                                {item.value}
                            </Typography>

                            <Typography
                                sx={{
                                    color: "#555",
                                    fontSize: "8px",
                                    fontWeight: 800,
                                    letterSpacing: "1.5px",
                                    mt: 0.4,
                                }}
                            >
                                {item.label}
                            </Typography>
                        </Box>
                    ))}
                </Box>

                {/* =====================================
                    BOTTOM BRAND
                ===================================== */}

                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mt: 5,
                        gap: 2,
                    }}
                >
                    <Box
                        sx={{
                            width: {
                                xs: 45,
                                sm: 70,
                            },
                            height: "1px",
                            background:
                                "linear-gradient(90deg, transparent, rgba(255,84,32,0.25))",
                        }}
                    />

                    <Typography
                        sx={{
                            color: "#444",
                            fontSize: "10px",
                            fontWeight: 700,
                            letterSpacing: "2px",
                            textTransform: "uppercase",
                        }}
                    >
                        Vex Conquer • 5165 Classic
                    </Typography>

                    <Box
                        sx={{
                            width: {
                                xs: 45,
                                sm: 70,
                            },
                            height: "1px",
                            background:
                                "linear-gradient(90deg, rgba(255,84,32,0.25), transparent)",
                        }}
                    />
                </Box>
            </Container>
        </Box>
    );
};

export default ServerNews;

